var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcRideBookings(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 36,
    viewBox: "0 0 40 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 6C12 4.34315 13.3431 3 15 3H25C26.6569 3 28 4.34315 28 6V18H12V6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 20C10 18.8954 10.8954 18 12 18H28C29.1046 18 30 18.8954 30 20V23C30 24.1046 29.1046 25 28 25H12C10.8954 25 10 24.1046 10 23V20Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 14C5 12.3431 6.34315 11 8 11H32C33.6569 11 35 12.3431 35 14V17C33.6193 17 32.5 18.1193 32.5 19.5C32.5 20.8807 33.6193 22 35 22V25C35 26.6569 33.6569 28 32 28H8C6.34315 28 5 26.6569 5 25V22C6.38071 22 7.5 20.8807 7.5 19.5C7.5 18.1193 6.38071 17 5 17V14ZM16.5 15H13.5V24H16.5V15ZM26.5 16.5L20 22.5L18 20.5L19.2 19.3L20 20.1L25.3 15.3L26.5 16.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRideBookings);
export default __webpack_public_path__ + "static/media/ic_ride_bookings.cc92931a81b633bb8cc0ea76df3f7fe4.svg";
export { ForwardRef as ReactComponent };